module.exports = __webpack_public_path__ + "static/media/2.86bc0f1e.png";